<template>
  <@field.Control>{{@definition.description}}</@field.Control>
</template>
